import { render, staticRenderFns } from "./CompanyQuestionTwo.vue?vue&type=template&id=5a33887e&scoped=true&"
import script from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyQuestionTwo.vue?vue&type=style&index=0&id=5a33887e&prod&scoped=true&lang=css&"
import style1 from "./CompanyQuestionTwo.vue?vue&type=style&index=1&id=5a33887e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33887e",
  null
  
)

export default component.exports